import { render, staticRenderFns } from "./pressJoinsComponent.vue?vue&type=template&id=e22cdce6"
import script from "./pressJoinsComponent.vue?vue&type=script&lang=js"
export * from "./pressJoinsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports